import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { v_OrderGridSearchBus } from '@app/cp/shared/models/v_OrderGridSearchBus';

@Component({
    selector: 'order-search-grid',
    templateUrl: './order-search-grid.component.html',
    styleUrls: ['./order-search-grid.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderSearchGridComponent extends BaseGridUIComponent<v_OrderGridSearchBus, null, DQOIService> {

    constructor(globals: GlobalsService, svc_data: DQOIService) {
        super(globals);
        this.svc_data = svc_data;
    }
    @Input() searchText: string = "";

}
